module.exports = __webpack_public_path__ + "static/media/dashboard-1.9366342f.png";